import { translate } from 'i18n';
import { useContext } from 'react';

import { PurchaseOrderFormContext } from '../../contexts/PurchaseOrderFormContext';
import {
  FinancialDetailsSection,
  SellerAdditionalDetailsAndDocumentsSection,
  SellerDealDetailsSection,
  SellerLogisticsSection,
  SellerMaterialDetailsSection,
  SellerPartiesSection,
} from '..';

export const PurchaseOrderFormSections = () => {
  const { documents: uploadedDocuments } = useContext(PurchaseOrderFormContext);

  return (
    <>
      <SellerPartiesSection />
      <SellerMaterialDetailsSection />
      <SellerDealDetailsSection />
      <SellerLogisticsSection />
      <FinancialDetailsSection isBuyer={false} currencyPriceName="seller_currency" />
      <SellerAdditionalDetailsAndDocumentsSection
        externalReferenceNumberLabel={translate(
          'sellerAdditionalDetailsAndDocumentsSection.labels.externalReferenceNumber',
          { namespace: 'orders' }
        )}
        uploadedDocuments={uploadedDocuments}
      />
    </>
  );
};
